// extracted by mini-css-extract-plugin
export default {"houseModal":"houseModal_houseModal__guDP8"};